import type { DropdownProps } from "@fluentui/react-components";
import { Dropdown, Option } from "@fluentui/react-components";
import { IDropdownProps } from "./Model";
import { DisplayLabelDropdownWrapper } from "./Style";

const DropdownCustom = (props: Partial<IDropdownProps & DropdownProps>) => {
  const renderLabelHasIconLeft = (): JSX.Element | undefined => {
    if (props.iconLeft) {
      return (
        <DisplayLabelDropdownWrapper className="DisplayLabelDropdownWrapper" $theme={props.theme} $isActive={!!props.value}>
          {props.iconLeft} <label className="label-dropdown">{props.value || props.placeholder}</label>
        </DisplayLabelDropdownWrapper>
      );
    } else {
      return undefined;
    }
  };

  return (
    <Dropdown {...props} button={renderLabelHasIconLeft()} style={{width: "100%"}}>
      {props.options
        ? (props.options || []).map((option) => (
            <Option key={`${option.value}`}>{option.text}</Option>
          ))
        : props.children}
    </Dropdown>
  );
};

export default DropdownCustom;
